import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './components/AuthProvider';
import { IdentityProviderWrapper } from './components/IdentityProviderWrapper';
import { IdentityTokenBridge } from './components/IdentityTokenBridge';
import { LoginCallback } from './pages/LoginCallback';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element with id "root" not found');
}

const root = ReactDOM.createRoot(rootElement);

/**
 * Simple path-based routing for the login callback
 * The app doesn't use a router, so we handle the callback route manually
 */
const isLoginCallbackRoute = window.location.pathname === '/login/callback';

root.render(
  <React.StrictMode>
    <IdentityProviderWrapper>
      {isLoginCallbackRoute ? (
        <LoginCallback />
      ) : (
        <IdentityTokenBridge>
          <AuthProvider>
            <App />
          </AuthProvider>
        </IdentityTokenBridge>
      )}
    </IdentityProviderWrapper>
  </React.StrictMode>
);

reportWebVitals();

